export default function NotificationsRoute() {
	return <p>Notifications</p>
}
